import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import Track from "./components/Track";
import Rank from "./components/Rank";
import Latest from "./components/Latest";
import Learn from "./components/Learn";
import About from "./components/About";
import Subscribe from "./components/Subscribe";
import { faqs } from "@/mocks/homeData";

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "今日大瓜",
  url: "https://xibuchuanqi.cn/",
  description: "每日聚合、梳理并解读被热议的娱乐与流行话题的资讯站点，坚持理性吃瓜。",
  email: "hello@jinridagua.example",
};

const webSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "今日大瓜",
  url: "https://xibuchuanqi.cn/",
  description: "今日大瓜是什么，今日大瓜是什么情况，一文看懂。每天一分钟看懂热搜话题。",
  inLanguage: "zh-CN",
  publisher: { "@type": "Organization", name: "今日大瓜" },
};

const pageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "今日大瓜 · 每天一分钟看懂热搜话题",
  url: "https://xibuchuanqi.cn/",
  inLanguage: "zh-CN",
  isPartOf: { "@type": "WebSite", name: "今日大瓜", url: "https://xibuchuanqi.cn/" },
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

function JsonLd({ data }: { data: object }) {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}

export default function Home() {
  return (
    <>
      <JsonLd data={orgSchema} />
      <JsonLd data={webSchema} />
      <JsonLd data={pageSchema} />
      <JsonLd data={faqSchema} />

      <Navbar />
      <main>
        <Hero />
        <Featured />
        <Track />
        <Rank />
        <Latest />
        <Learn />
        <About />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}